import classNames from 'classnames'
import type { FunctionalComponent } from 'preact'
import styles from './index.module.scss'

export type TextTag = 'span' | 'div' | 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'

type TextProps = {
  as?: TextTag
  upper?: boolean
  fontSize?: 12 | 13 | 14 | 15 | 16 | 18 | 20 | 22 | 24 | 34
  fontSizeMobile?: 12 | 13 | 14 | 15 | 16 | 18 | 24
  lineHeight?: 1 | 1.25 | 1.3
  fontWeight?: 400 | 500 | 600 | 700
  fontFamily?: 'PT Mono'
  textAlign?: 'left' | 'center' | 'right'
  opacity?: 0.3 | 0.4 | 0.5 | 0.7
  class?: string
  hidden?: boolean
}

export const Text: FunctionalComponent<TextProps> = props => {
  const Component = props.as ?? 'div'

  return (
    <Component
      hidden={props.hidden}
      class={classNames(
        styles.root,
        {
          [styles.upper]: props.upper,
        },
        props.class,
      )}
      style={{
        '--font-size-desktop': `${props.fontSize ?? 16}px`,
        '--font-size-mobile': `${props.fontSizeMobile ?? props.fontSize ?? 16}px`,
        lineHeight: props.lineHeight ?? 1.25,
        fontWeight: props.fontWeight,
        textAlign: props.textAlign,
        fontFamily: props.fontFamily,
        opacity: props.opacity,
      }}
    >
      {props.children}
    </Component>
  )
}
